<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dq2QH6/tc-custom/9781398454538.jpg?1705766066851" alt="This image is the cover for the book If You Wake at Midnight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If You Wake at Midnight
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the story of the greatest scandal inflicted on British servicemen and women in modern times: drug-induced violence and suicide – and an officer determined to find the truth. It was supposed to be a wonder drug that would save the world from malaria. But soon after Lariam was brought to international markets in the late 1980s, users of this handy, once-a-week pill began to experience shocking side-effects. Yet over the coming decades, as the drug became implicated in ever-increasing acts of unexplained violence, homicide and suicide, the Ministry of Defence continued to force Lariam on tens, or perhaps hundreds, of thousands of unsuspecting people deployed to some of the world’s most dangerous places. Enduring years of Lariam-induced nightmares, former soldier Andrew Marriott realised something was horribly wrong; not just with the drug itself but with the institutions responsible for its use and safety. So began a journey towards the truth, a truth that vested interests in the United Kingdom and around the globe were determined to conceal. In a unique exposé of an entirely preventable pharmaceutical disaster, Marriott turns a spotlight on the murky world of clandestine military and industrial research in the United States in which Lariam was developed. With other survivors, including some very courageous women, he undertakes a forensic examination of a scandal extending to the upper echelons of government and the armed forces. A culture of betrayal and dishonour had imperilled those defending our country to the most insidious and silent form of friendly fire.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Marriott
      </h2>
      
      <p class="authorDescription body article">Andrew Marriott was an army officer for over thirty years, seeing service in conflicts in Europe, the Middle East and West Africa. He received a commendation for devotion to duty as a platoon commander in Northern Ireland and was later awarded an MBE. He has since become an archaeologist and, after taking degrees at the University of York, in 2018, he was awarded a doctorate by Newcastle University. He is married with two daughters and lives in North Yorkshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bead420